import { render, staticRenderFns } from "./ScoutFormActiveRecent.vue?vue&type=template&id=10a5041a"
import script from "./ScoutFormActiveRecent.vue?vue&type=script&lang=js"
export * from "./ScoutFormActiveRecent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports